/** WP-EDU-016b — pure helpers for Education home attention compose (no task invent). */

export type AttendanceExceptionBoard = {
  unmarked?: unknown[];
  unmarked_periods?: unknown[];
  corrections?: unknown[];
  unexplained?: unknown[];
  repeated?: unknown[];
};

export type AttentionCounts = {
  unmarked: number;
  unmarkedPeriods: number;
  corrections: number;
  unexplained: number;
  repeated: number;
  exceptionTotal: number;
  openTasks: number;
};

export function summarizeAttendanceExceptions(board: AttendanceExceptionBoard | null | undefined): Omit<
  AttentionCounts,
  'openTasks'
> {
  const unmarked = board?.unmarked?.length ?? 0;
  const unmarkedPeriods = board?.unmarked_periods?.length ?? 0;
  const corrections = board?.corrections?.length ?? 0;
  const unexplained = board?.unexplained?.length ?? 0;
  const repeated = board?.repeated?.length ?? 0;
  return {
    unmarked,
    unmarkedPeriods,
    corrections,
    unexplained,
    repeated,
    exceptionTotal: unmarked + unmarkedPeriods + corrections + unexplained + repeated,
  };
}

export function buildAttentionCounts(
  board: AttendanceExceptionBoard | null | undefined,
  openTasks: number
): AttentionCounts {
  return {
    ...summarizeAttendanceExceptions(board),
    openTasks: Math.max(0, openTasks || 0),
  };
}
